
import { fetchCollection } from '@/services/base'
import Transformer from '@/transformers/transformer'
import unitTransformer from '@/transformers/catalogs/services/unitMeasurement'
import familyTransformer from '@/transformers/catalogs/services/family'
import zoneTransformer from '@/transformers/catalogs/zones'
import fileTypeTransformer from '@/transformers/commons/fileType/'
import jobTypeTransformer from '@/transformers/sinister/jobType'
import supplyTypeTransformer from '@/transformers/catalogs/services/supplyType'
import customerTransformer from '@/transformers/catalogs/customer.js'
import AccountTransformer from '@/transformers/account/MinimalAccount.js'

import { SUPERVISOR_GROUP, ACO_CM_QUA_GROUP, AUX_CM_GROUP, ACO_GROUP, ESAT_GROUP } from '@/router/utils'

const fetchUnitsMeasurement = () =>
  fetchCollection('unit_measurement',
    {
      useStore: 'catalogs',
      urlGroup: 'commons',
      sortValue: 'name',
      useTransformer: unitTransformer
    })
const fetchStates = () =>
  fetchCollection('states',
    {
      useStore: 'catalogs',
      urlGroup: 'commons',
      sortValue: 'name',
      useTransformer: Transformer
    })

const fetchFamilies = () =>
  fetchCollection('family',
    {
      useStore: 'catalogs',
      urlGroup: 'catalogs/services',
      sortValue: 'name',
      useTransformer: familyTransformer
    })

const fetchZones = () =>
  fetchCollection('zones',
    {
      useStore: 'catalogs',
      urlGroup: 'catalogs',
      sortValue: 'name',
      useTransformer: zoneTransformer
    })

const fetchCustomers = () =>
  fetchCollection('customer',
    {
      useStore: 'catalogs',
      // urlGroup: 'customer',
      sortValue: 'name',
      useTransformer: customerTransformer
    })
const fetchJobTypes = () =>
  fetchCollection('job_type',
    {
      useStore: 'catalogs',
      urlGroup: 'sinister',
      sortValue: 'name',
      useTransformer: jobTypeTransformer
    })

const fetchSupplyTypes = () =>
  fetchCollection('supply-type',
    {
      useStore: 'catalogs',
      urlGroup: 'catalogs/services',
      sortValue: 'name',
      useTransformer: supplyTypeTransformer
    })
const fetchFileTypes = () =>
  fetchCollection('file_type',
    {
      useStore: 'catalogs',
      urlGroup: 'commons',
      sortValue: 'name',
      useTransformer: fileTypeTransformer
    })
const fetchCasualtyFileTypes = () =>
  fetchCollection('affected',
    {
      useStore: 'catalogs',
      urlGroup: 'sinister/files-type',
      sortValue: 'name',
      useTransformer: fileTypeTransformer
    })

const fetchContactClassification = () =>
  fetchCollection('initial_contact_classification',
    {
      useStore: 'catalogs',
      urlGroup: 'commons',
      sortValue: 'sort_index'
    })

const fetchSupervisors = () =>
  fetchCollection(`by_group/${SUPERVISOR_GROUP}`,
    {
      useStore: 'catalogs',
      urlGroup: 'users',
      params: '?not_filter=1&minimal=true',
      useTransformer: AccountTransformer
    })

const fetchACos = () =>
  fetchCollection(`by_group/${ACO_GROUP}`,
    {
      useStore: 'catalogs',
      urlGroup: 'users',
      params: '?minimal=true',
      useTransformer: AccountTransformer
    })
const fetchACoCMQUA = () =>
  fetchCollection(`by_group/${ACO_CM_QUA_GROUP}`,
    {
      useStore: 'catalogs',
      urlGroup: 'users',
      params: '?&minimal=true',
      useTransformer: AccountTransformer
    })
const fetchAuxCM = () =>
  fetchCollection(`by_group/${AUX_CM_GROUP}`,
    {
      useStore: 'catalogs',
      urlGroup: 'users',
      params: '?minimal=true',
      useTransformer: AccountTransformer
    })
const fetchEsAt = () =>
  fetchCollection(`by_group/${ESAT_GROUP}`,
    {
      useStore: 'catalogs',
      urlGroup: 'users',
      params: '?minimal=true',
      useTransformer: AccountTransformer
    })

export default () => [
  fetchUnitsMeasurement(),
  fetchStates(),
  fetchFamilies(),
  fetchCustomers(),
  // fetchDetails(),
  fetchZones(),
  fetchJobTypes(),
  // fetchClients(),
  fetchSupplyTypes(),
  fetchFileTypes(),
  fetchCasualtyFileTypes(),
  fetchContactClassification(),
  fetchSupervisors(),
  fetchACos(),
  fetchACoCMQUA(),
  fetchAuxCM(),
  fetchEsAt()
]
